import {
  MutationTuple,
  QueryResult,
  useMutation,
  useQuery,
} from '@apollo/client';
// Api
import { GET_CB_COMPANY_PREFERENCES } from 'api/cbCompanyPreferences/queries';
import { EDIT_CB_COMPANY_PREFERENCES } from 'api/cbCompanyPreferences/mutations';
// Types
import {
  GetCbCompanyPreferences,
  GetCbCompanyPreferencesVariables,
} from 'api/cbCompanyPreferences/types/GetCbCompanyPreferences';
import {
  EditCbCompanyPreferences,
  EditCbCompanyPreferencesVariables,
} from 'api/cbCompanyPreferences/types/EditCbCompanyPreferences';

type UseGetCbCompanyPreferencesOptions = {
  ownerId?: string | null;
  skip?: boolean;
};

/** Reads the preference set of the brand the admin names. */
export const useGetCbCompanyPreferences = ({
  ownerId,
  skip = false,
}: UseGetCbCompanyPreferencesOptions): QueryResult<
  GetCbCompanyPreferences,
  GetCbCompanyPreferencesVariables
> =>
  useQuery<GetCbCompanyPreferences, GetCbCompanyPreferencesVariables>(
    GET_CB_COMPANY_PREFERENCES,
    {
      variables: { input: { ownerId } },
      skip: skip || !ownerId,
      // Admin tooling: always read the row as it stands, never a cached copy.
      fetchPolicy: 'network-only',
    }
  );

export const useEditCbCompanyPreferences = (): MutationTuple<
  EditCbCompanyPreferences,
  EditCbCompanyPreferencesVariables
> =>
  useMutation<EditCbCompanyPreferences, EditCbCompanyPreferencesVariables>(
    EDIT_CB_COMPANY_PREFERENCES
  );
